import Menus from "../Menus";

const HelpTopicPayInscription = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
  ]

  const multiMenus = [
    {title: 'Fonctionnement des paiements', filter: 'HelpTopicPayInscription_1', moreIds: [32]},
    {title: 'Modes de paiement', filter: 'HelpTopicPayInscription_2'},
    {title: 'Résolution de problèmes de paiement', filter: 'HelpTopicPayInscription_3'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicPayInscription